import React from 'react';
import { currentOrganisationType } from '../../../auth/redux/authActions';
import { Field } from 'redux-form';
import Communications from '../Communications';
import { Marketing } from '../Marketing';
import { Row, Col } from 'react-bootstrap';
import getCommunicationOptionsContent from '../../../../helpers/getCommunicationOptionsContent';

const CommunicationsMarketingSection = ({
  onMarketingOptionsChange,
  onCommunicationOptionsChange,
  isMarketingEnabled,
  isInsuranceMarketingOptionsEnabled,
  isCarInsuranceMarketingEnabled,
  isHomeInsuranceMarketingEnabled,
  marketingOptions,
}) => {
  return (
    <Row style={{ paddingBottom: '25px' }}>
      <Col sm={6}>
        <Field
          name="data.attributes.metadata.communications"
          component={Communications}
          content={getCommunicationOptionsContent(currentOrganisationType())}
          communicationTypes={Object.keys(
            getCommunicationOptionsContent(currentOrganisationType())[
              'communication_types'
            ],
          )}
          onCommunicationOptionsChange={onCommunicationOptionsChange}
        />
      </Col>
      <Col sm={6}>
        <Marketing
          label="Marketing"
          name="data.attributes.metadata.adults[0].marketing_options"
          handleMarketingOptionsChange={onMarketingOptionsChange}
          showText
          isMarketingEnabled={isMarketingEnabled}
          isInsuranceMarketingOptionsEnabled={isInsuranceMarketingOptionsEnabled}
          marketingOptions={marketingOptions}
          isHomeInsuranceMarketingEnabled={isHomeInsuranceMarketingEnabled}
          isCarInsuranceMarketingEnabled={isCarInsuranceMarketingEnabled}
        />
      </Col>
    </Row>
  );
};
export default CommunicationsMarketingSection;
